<div class="pages-layout">
  <header class="pages-header">
    <div class="header-breadcrumb-container">
      <img
        src="/assets/images/flydocs.png"
        alt="flydocs Logo"
        class="header-logo"
      />
    </div>
    <hr class="divider" />
  </header>

  <main class="pages-content">
    <div class="content-layout">
      <div class="content-layout__main">
        <div class="content-layout__main-inner" id="pdf-container"></div>
      </div>
      @if (sharedPackDetails) {
        <div class="content-layout__sidebar">
          <h3>
            {{ sharedPackDetails?.template?.name }}
            @if (sharedPackDetails?.link.permission !== "VIEW_ONLY") {
              <img
                src="/assets/images/icons/download.svg"
                alt=""
                pTooltip="{{ 'Download' }}"
                [tooltipPosition]="'bottom'"
                (click)="downloadPack(sharedPackDetails?.link.token)"
              />
            }
          </h3>
          <div class="fields">
            <span class="fields__label">Serial Number</span>
            <span class="fields__value">
              {{ sharedPackDetails?.component.serialNumber }}
            </span>
          </div>
          <div class="fields">
            <span class="fields__label">Part Number</span>
            <span class="fields__value">
              {{ sharedPackDetails?.component.partNumber }}
            </span>
          </div>
          <div class="doc-manifest">
            <div class="doc-manifest__container">
              @if (documentChecklist?.length) {
                @for (item of documentChecklist; track $index) {
                  <ng-container
                    *ngTemplateOutlet="
                      manifestDocTemplate;
                      context: { item: item, isRecentDocs: false }
                    "
                  />
                }
              }
            </div>
          </div>
        </div>
      }
    </div>
  </main>
</div>

<ng-template
  #manifestDocTemplate
  let-item="item"
  let-isRecentDocs="isRecentDocs"
>
  <div class="doc-detail">
    <div class="doc_status">
      <div>
        <img
          [src]="
            isRecentDocs
              ? item.attached
                ? '/assets/images/icons/green-dot.svg'
                : '/assets/images/icons/red-dot.svg'
              : item.status === 'missing'
                ? '/assets/images/icons/red-dot.svg'
                : '/assets/images/icons/green-dot.svg'
          "
          alt=""
        />
      </div>
      <div class="doc_name">
        <div class="doc_title">
          {{ item.title | translate: textTranslation }}
        </div>
        <div class="doc_filename">
          {{ item.fileName | translate: textTranslation }}
        </div>
      </div>
    </div>
    <div class="doc_status">
      @if (item.date) {
        <span class="doc_date">{{ item.date }} </span>
      }
    </div>
  </div>
</ng-template>
